<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import './element-variables.scss';
import './styles/main.scss';

export default {
    name: 'app',
};
</script>

<style>
body,
html {
    padding: 0;
    margin: 0;
    background: #fff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
        'Segoe UI Symbol';
    font-size: 16px;
}

.editr {
    background: #fff;
    box-sizing: border-box;
}

.group__headline {
    margin-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-weight: normal;
    border-bottom: 2px solid #e4e7ed;
}

.u__margin-bottom {
    margin-bottom: 35px;
}

.u__margin-top {
    margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// App.vue?65701e0c